import React, { useState } from 'react';
import Login from './components/Login';
import DeviceList from './components/DeviceList';
import SmsMessages from './components/SmsMessages';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const handleLogin = (loginStatus) => {
    setIsLoggedIn(loginStatus);
  };

  const handleDeviceSelect = (device) => {
    setSelectedDevice(device);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setSelectedDevice(null);
  };

  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <h1>📱 SMS Admin Panel</h1>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </header>
      
      <div className="main-content">
        <div className="left-panel">
          <DeviceList 
            onDeviceSelect={handleDeviceSelect} 
            selectedDeviceId={selectedDevice?.id}
          />
        </div>
        
        <div className="right-panel">
          <SmsMessages selectedDevice={selectedDevice} />
        </div>
      </div>
    </div>
  );
}

export default App;
